import React from 'react';
import { useEscapeKey } from '../../hooks/useEscapeKey';

const AuctionImagesModal = ({ isOpen, onClose, onConfirm, imageCount }) => {
  if (!isOpen) return null;
  
  useEscapeKey(onClose, isOpen);

  return (
    <div className="fixed inset-0 bg-black/50 z-[60] flex items-center justify-center">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6">
        <h3 className="text-lg font-medium text-gray-900 mb-4">
          Additional Images Found
        </h3>
        
        <p className="text-sm text-gray-500 mb-6">
          {imageCount} additional auction house {imageCount === 1 ? 'image was' : 'images were'} found for this certification. 
          Would you like to include {imageCount === 1 ? 'it' : 'them'}?
        </p>

        <div className="flex justify-end space-x-3">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50"
          >
            No
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className="px-4 py-2 border border-transparent rounded-md text-sm font-medium text-white bg-blue-600 hover:bg-blue-700"
          >
            Yes, Include {imageCount === 1 ? 'It' : 'Them'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AuctionImagesModal;
